let myModalProgress = document.getElementById('modalProgress');
let pregressBarValue = 0;

function UpdateProgressBar(changeValue) {
    $('.progress-bar').css('width', changeValue + '%').attr('aria-valuenow', changeValue);
}

function StartGroupUpdate(formId) {
    $(
        formId + ' .start-group input,' +
        formId + ' .start-group select').on('input change focusout', function () {
            let total = $(
                formId + ' .start-group input,' +
                formId + ' .start-group select').length;
            let completedInput = $(formId + ' .start-group input').not(".wpcf7-not-valid").filter(function () {
                return $(this).val().length >= 1;
            }).length;
            let completedselect = $(formId + ' .start-group select option:selected[value!=""]').length;
            let completed = completedInput + completedselect;

            if (completed === total) {
                $(
                    formId + ' .second-group,' +
                    formId + ' .form-group_btns').removeClass('hidden');
                UpdateProgressBar(66.66);
            } else {
                $(
                    formId + ' .second-group,' +
                    formId + ' .form-group_btns').addClass('hidden');
                UpdateProgressBar(33.33);
            }
        });
}

function SecondGroupUpdate(formId) {
    $(
        formId + ' .second-group input,' +
        formId + ' .second-group textarea,' +
        formId + ' .second-group select,' +
        formId + ' .form-group_btns input').on('input change focusout', function () {
            let total = $(
                formId + ' .second-group input,' +
                formId + ' .second-group textarea,' +
                formId + ' .second-group select').length;
            let completedInput = $(
                formId + ' .second-group input,' +
                formId + ' .second-group textarea').not(".wpcf7-not-valid").filter(function () {
                return $(this).val().length >= 1;
            }).length;
            let completedselect = $(formId + ' .second-group select option:selected[value!=""]').length;
            let completed = completedInput + completedselect;

            let checkboxStatus = $(formId + ' input[type=checkbox]').is(':checked');

            if (completed === total && checkboxStatus) {
                $(formId + ' .form-group_btns .rd-btn').removeClass('disabled');
                UpdateProgressBar(100);
            } else {
                $(formId + ' .form-group_btns .rd-btn').addClass('disabled');
                UpdateProgressBar(66.66);
            }
    });
}

function setContactModalProgress(modalItem) {
    let modalID = $('#' + modalItem);

    modalID.on('shown.bs.modal', function (e) {
        let formItems = $(this).find('.form-holder');

        $(this).find('.buttons-check input[type="radio"]').on('change', function () {
            let radioValue = $(this).val();
            let radioName = $(this).attr('data-attr');

            $('#' + radioName).find('form input[name=i-represent]').val(radioValue);

            $('#' + radioName).show().siblings('.form-holder').hide();

            formItems.find('.wpcf7-form').each(function () {
                
                $(this).find('.form-control').each(function () {
                    let fieldName = $(this).attr("name");
                    if (fieldName !== "user-name" && fieldName !== "user-email") {
                        $(this).val('').trigger('change');
                        $(this).parent().parent('.form-field').removeClass('not-empty');
                    }
                });
            });
            UpdateProgressBar(33.33);
        });

        formItems.each(function () {
            let formId = '#' + $(this).attr('id');

            StartGroupUpdate(formId);
            SecondGroupUpdate(formId);

        });
    });

    modalID.on('hidden.bs.modal', function (e) {
        $(this).find('.buttons-check input[type="radio"]').prop('checked', false);
        $(this).find('.form-holder').not('.form-holder-single').hide();
        UpdateProgressBar(0);
    });
}

(function () {
    let arr = [];

    $('.rd-modal-progress').each(function () {
        arr.push($(this).attr('id'));
    });
    [...new Set(arr)].forEach(element => setContactModalProgress(element));
})();